export default __webpack_public_path__ + "103a36fb1fd145b3b966d019d595f18f.svg";